import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import isObject from '@cotyorg/ccx-utils/js/helpers/isObject';
import MobileNavigation from '../MobileNavigation';
import MobileNavigationVerticalAccordion from './MobileNavigationVerticalAccordion';
import MobileNavigationContainer from '../../containers/MobileNavigationContainer';

const generateNavigationClassNames = ({ isVisible }) => classNames(
  'mobile-navigation__section',
  'flex-column',
  'mobile-navigation-vertical__section', {
    'mobile-navigation__section--visible': isVisible,
  },
);

const PageComponent = ({
  page,
  navigation,
  goBackDone,
  plusIconSrc,
  minusIconSrc,
}) => {
  const isVisible = (
    isObject(navigation) &&
    Array.isArray(navigation.displayedPages) &&
    navigation.displayedPages.includes(page.slug)
  );
  const shouldRenderContent = isVisible || navigation.goingBack;

  return (
    <div
      className={generateNavigationClassNames({ isVisible })}
      onTransitionEnd={(e) => {
        if (e.propertyName === 'transform' && navigation.goingBack) {
          goBackDone();
        }
      }}
    >
      { shouldRenderContent && (
        <MobileNavigationVerticalAccordion
          pages={page.pages}
          plusIconSrc={plusIconSrc}
          minusIconSrc={minusIconSrc}
        />
      ) }
    </div>
  );
};

PageComponent.propTypes = {
  page: PropTypes.shape({
    slug: PropTypes.string.isRequired,
    pages: PropTypes.array,
  }),
  navigation: PropTypes.shape({
    displayedPages: PropTypes.array.isRequired,
    goingBack: PropTypes.bool,
  }),
  goBackDone: PropTypes.func.isRequired,
  plusIconSrc: PropTypes.string,
  minusIconSrc: PropTypes.string,
};

const MobileNavigationVertical = ({
  isVisible,
  plusIconSrc,
  minusIconSrc,
}) => (
  <MobileNavigationContainer
    isVisible={isVisible}
    PageComponent={PageComponent}
    childComponent={MobileNavigation}
    plusIconSrc={plusIconSrc}
    minusIconSrc={minusIconSrc}
  />
);

MobileNavigationVertical.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  plusIconSrc: PropTypes.string,
  minusIconSrc: PropTypes.string,
};

export default MobileNavigationVertical;
